import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "order",
    serviceName: "auth",
    query: gql`
      query order(
        $ids: [String]
        $lab_ids: [String]
        $unit_ids: [String]
        $doctor_ids: [String]
        $page: Int
        $limit: Int
        $for_admin: Int
      ) {
        order(
          ids: $ids
          lab_ids: $lab_ids
          unit_ids: $unit_ids
          doctor_ids: $doctor_ids
          page: $page
          limit: $limit
          for_admin: $for_admin
        ) {
          total
          data {
            id
            tracking_code
            created_at
            demand_time
            delivery_time
            total_cost
            lab {
              title
              media {
                full_url
              }
            }
            unit {
              title
              media {
                full_url
              }
            }
            customer {
              firstname
              lastname
            }
            doctor {
              lastname
              firstname
            }
            status {
              id
              title
            }
          }
        }
      }
    `,
  },
  delete: {
    name: "deleteOrder",
    serviceName: "admin",
    query: gql`
      mutation deleteOrder($ids: [String]!) {
        deleteOrder(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  assignment: {
    name: "order",
    serviceName: "auth",
    query: gql`
      query order($ids: [String]) {
        order(ids: $ids) {
          data {
            id
            title
            media {
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
